/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { ErrorMessage } from "@advapacs/common";
import { createSlice } from "@reduxjs/toolkit";

export interface ISessionsResponse {
  id?: string;
  ip?: string;
  location?: string;
  device?: string;
  createdAt?: string;
  current?: boolean;
  expiresAt?: string;
}

export const initialState = {
  errorMessage: null as ErrorMessage,
  loading: false as boolean,
  sessions: [] as ISessionsResponse[],
};

const AccountSlice = createSlice({
  name: "accountReducer",
  initialState,
  reducers: {
    getSessionsStart(state) {
      state.loading = true;
    },
    getSessionsSuccess(state, action) {
      state.loading = false;
      state.sessions = action.payload;
    },
    getSessionsFail(state, action) {
      state.loading = false;
      state.errorMessage = action.payload;
    },
  },
});

export const AccountActions = AccountSlice.actions;
export default AccountSlice.reducer;
